import gql from 'graphql-tag';
export const competitionAdAllocationFragment = gql `
  fragment CompetitionAdAllocation on EntityAdAllocation {
    id
    entityId
    entity {
      ... on Team {
        id
        name
        sport {
          id
          name
        }
      }
      ... on Competition {
        id
        name
        sport {
          id
          name
        }
      }
    }
    adSets {
      adSetAllocations {
        id
        percentage
        events
        entityAdAllocationId
      }
      id
      name
      adFiles {
        file {
          url
          id
        }
        size
        adSetId
      }
      teamId
    }
    config {
      events
      teams {
        home {
          percentage
          enabled
        }
        away {
          percentage
          enabled
        }
      }
      loop {
        enabled
        type
        secsBetweenShows
        secsPerShow
        perPeriod
      }
    }
  }
`;
//# sourceMappingURL=CompetitionAdAllocation.js.map